import React from 'react'
import { ContainerWrapper, TCPTopBarWrapper } from '../StyledComponent'
import {
	Search,
	LanguageSwitcher,
	FontSizeController,
	ThemeSwitcher,
	TopIcons,
} from '../../NewUDHome/Header/Components'

function TopBar() {
	return (
		<TCPTopBarWrapper>
			<ContainerWrapper>
				<Search />
				<LanguageSwitcher />
				<FontSizeController />
				<ThemeSwitcher />
				<TopIcons />
			</ContainerWrapper>
		</TCPTopBarWrapper>
	)
}

export default TopBar
